import PostRow from "./PostRow.jsx";
import { certificates } from "../data.js";
import { localizeDateLabel, localizeField } from "../i18n.js";
import { useState } from "react";

export const getCertificateSlug = (cert) =>
  cert.slug ||
  cert.id ||
  cert.title
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase();

export default function CertificatesPage({ t, copy, language }) {
  const sortedCertificates = [...certificates].sort((a, b) => {
    if (!a.issued) return 1;
    if (!b.issued) return -1;

    const parseDate = (str) => new Date(str.replace(/\./g, ""));
    return parseDate(b.issued) - parseDate(a.issued);
  });

  const [seeAll, setSeeAll] = useState(false);

  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 400, marginBottom: 18 }}>
        {copy.certificates}
      </h2>

      <div>
        {sortedCertificates.slice(0,3).map((cert, i) => (
          <PostRow
            key={cert.id || `${cert.title}-${cert.issued}`}
            root="certificates"
            path={getCertificateSlug(cert)}
            label={localizeDateLabel(cert.issued, language)}
            title={localizeField(cert, "title", language)}
            subtitle={localizeField(cert, "issuer", language)}
            isFirst={i === 0}
            link
            t={t}
            copy={copy}
          />
        ))}
        {seeAll && sortedCertificates.slice(3).map((cert) => (
            <PostRow
              key={cert.id || `${cert.title}-${cert.issued}`}
              root="certificates"
              path={getCertificateSlug(cert)}
              label={localizeDateLabel(cert.issued, language)}
              title={localizeField(cert, "title", language)}
              subtitle={localizeField(cert, "issuer", language)}
              link
              t={t}
              copy={copy}
            />
          ))}
          {sortedCertificates.length > 3 && (
            <button
              type="button"
              onClick={() => setSeeAll((value) => !value)}
              style={{
                marginTop: 10,
                padding: 0,
                border: 0,
                background: "transparent",
                font: "inherit",
                fontSize: 14,
                color: t.dim,
                cursor: "pointer",
              }}
            >
              {seeAll ? (
                  copy.seeLess
                ) : (
                  copy.seeAll
              )}
            </button>
          )}
      </div>
    </div>
  );
}
